import { type GetHookResponse } from '../hooks'
import { videoSearchKey } from '../keys'
import { useTantalimQuery } from '../query'
import { HOUR, type VideoSearchInput, type VideoSearchSuccess } from '@terros/common'

export function useVideoSearch(input: VideoSearchInput, enabled = true): GetHookResponse<VideoSearchSuccess> {
  return useTantalimQuery<VideoSearchInput, VideoSearchSuccess, VideoSearchSuccess>({
    convertResponse: (data) => data,
    input,
    queryKey: videoSearchKey(input),
    url: '/video/search',
    options: {
      enabled,
      staleTime: HOUR,
      gcTime: HOUR,
    },
  })
}
